import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.8682 4.5472L16.4105 2.99615L14.9923 1.58594L12.5707 4.02127C12.411 3.70572 12.2085 3.42613 11.9664 3.18304C11.32 2.53394 10.4985 2.25346 9.78233 2.13936C9.06306 2.02476 8.36798 2.06417 7.87079 2.12497C7.61807 2.15588 7.40643 2.1936 7.25539 2.22423C6.65163 2.34664 6.05636 2.51255 5.46186 2.67824C5.19355 2.75301 4.92541 2.82775 4.65671 2.89842L7.76057 4.70407L7.72517 4.71398C6.13837 5.16753 4.67724 5.97107 3.62223 7.35457C2.56694 8.73845 2.00016 10.5948 2 12.9999C1.9998 16.0065 3.11121 18.305 4.99588 19.8298C6.84999 21.3299 9.34671 21.9973 12 21.9973C14.6523 21.9973 17.1497 21.3332 19.0045 19.8345C20.8903 18.3107 22.0015 16.0115 22 12.9994C21.9988 10.5846 21.4109 8.72948 20.3475 7.3496C19.2863 5.97258 17.8307 5.17157 16.2822 4.71611C15.8418 4.58658 15.3508 4.54298 14.8682 4.5472ZM7 8H9.00391V10.0039H7V8ZM5 11H7.00391V13.0039H5V11ZM9.00391 14V16.0039H7V14H9.00391Z"}}]};

const TangerinrFilled = Vue.extend<IconProps>({
  name: 'TangerinrFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'tangerinr-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TangerinrFilled;
